export default __webpack_public_path__ + "static/media/question.51c452d4.svg";